import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Like1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.662 3.377a3.98 3.98 0 0 0-2.46 1.04l-.035.033.101.1a3.95 3.95 0 0 0-2.826-1.18 3.98 3.98 0 0 0-2.855 1.208 4.54 4.54 0 0 0-.198 6.086c.313.382.685.789 1.087 1.196l.412.407c1.54 1.487 3.381 2.874 4.213 2.965h.132c.68-.075 2.037-1.017 3.353-2.172l.436-.393.427-.402a19 19 0 0 0 1.502-1.609 4.54 4.54 0 0 0-.202-6.077 3.98 3.98 0 0 0-2.857-1.209zm.23 1.193a2.78 2.78 0 0 1 1.995.844 3.34 3.34 0 0 1 .142 4.474l-.143.17c-.196.23-.416.472-.652.717l-.364.368-.38.37-.391.363-.394.353-.392.337-.193.16-.376.303c-.675.53-1.255.911-1.565.995l-.012.001.066.014c-.236-.025-.708-.308-1.285-.736l-.357-.273-.186-.148-.383-.315-.391-.337a27 27 0 0 1-.394-.352l-.39-.363-.38-.368c-.435-.43-.835-.86-1.156-1.252a3.34 3.34 0 0 1 .138-4.483 2.78 2.78 0 0 1 3.988.002l.73.659.701-.631a2.8 2.8 0 0 1 2.024-.872"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Like1$1 = Svg18Like1;

export { Svg18Like1$1 as default };
